<template>

<div class="skills_scores_container container">

    <div class="columns" v-if="scores">
        <div class="column">
            <div class="scores_columns_container">

                <h3 class="dim_cat_title">{{ $t('dimensions.skills_titles.title1') }}</h3>
                <SkillScore :score="scores.r1" :refScore="refScores.r1" :scoreDelay="1" :scoreDecal="1" :scoreLabel="labels.r1" />
                <SkillScore :score="scores.r2" :refScore="refScores.r2" :scoreDelay="2" :scoreDecal="2" :scoreLabel="labels.r2" />
                <h3 class="dim_cat_title">{{ $t('dimensions.skills_titles.title3') }}</h3>
                <SkillScore :score="scores.r8" :refScore="refScores.r8" :scoreDelay="1" :scoreDecal="1" :scoreLabel="labels.r8" />
                <SkillScore :score="scores.r9" :refScore="refScores.r9" :scoreDelay="2" :scoreDecal="2" :scoreLabel="labels.r9" />
            </div>
        </div>

        <div class="column">
            <div class="scores_columns_container">
                <h3 class="dim_cat_title">{{ $t('dimensions.skills_titles.title4') }}</h3>
                <SkillScore :score="scores.r10" :refScore="refScores.r10" :scoreDelay="3" :scoreDecal="3" :scoreLabel="labels.r10" />
                <SkillScore :score="scores.r11" :refScore="refScores.r11" :scoreDelay="4" :scoreDecal="4" :scoreLabel="labels.r11" />
                <SkillScore :score="scores.r12" :refScore="refScores.r12" :scoreDelay="5" :scoreDecal="5" :scoreLabel="labels.r12" />
                <SkillScore :score="scores.r13" :refScore="refScores.r13" :scoreDelay="6" :scoreDecal="6" :scoreLabel="labels.r13" />
                <SkillScore :score="scores.r14" :refScore="refScores.r14" :scoreDelay="7" :scoreDecal="7" :scoreLabel="labels.r14" />
                <SkillScore :score="scores.r15" :refScore="refScores.r15" :scoreDelay="8" :scoreDecal="8" :scoreLabel="labels.r15" />
                <SkillScore :score="scores.r16" :refScore="refScores.r16" :scoreDelay="9" :scoreDecal="9" :scoreLabel="labels.r16" />
                <SkillScore :score="scores.r17" :refScore="refScores.r17" :scoreDelay="10" :scoreDecal="10" :scoreLabel="labels.r17" />
            </div>
        </div>

        <div class="column">
            <div class="scores_columns_container">
                <h3 class="dim_cat_title">{{ $t('dimensions.skills_titles.title2') }}</h3>
                <SkillScore :score="scores.r3" :refScore="refScores.r3" :scoreDelay="3" :scoreDecal="3" :scoreLabel="labels.r3" />
                <SkillScore :score="scores.r4" :refScore="refScores.r4" :scoreDelay="4" :scoreDecal="4" :scoreLabel="labels.r4" />
                <SkillScore :score="scores.r5" :refScore="refScores.r5" :scoreDelay="5" :scoreDecal="5" :scoreLabel="labels.r5" />
                <SkillScore :score="scores.r6" :refScore="refScores.r6" :scoreDelay="6" :scoreDecal="6" :scoreLabel="labels.r6" />
                <SkillScore :score="scores.r7" :refScore="refScores.r7" :scoreDelay="7" :scoreDecal="7" :scoreLabel="labels.r7" />
            </div>
        </div>
    </div>
</div>

</template>

<script>
import SkillScore from "./skillScore";
import s3SkillsLabels from '@/locales/s3SkillsLabels'

export default {
    name: 'SkillsScores',
    props: ['scores', 'refScores'],
    components: {
        SkillScore
    },
    mounted() {},
    data(){
        return {
            localMatching: 0,
            localFiability: 0,
            matchingRange: 'low',

        }
    },
    computed: {
        labels(){
            return s3SkillsLabels[this.$i18n.locale]
        }
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.skills_scores_container{
    margin: 20px auto;
    .scores_columns_container{
        .dim_cat_title{
            max-width: 280px;
            min-width: 280px;
        }
        .scores_container{
            max-width: 280px;
            min-width: 280px;
        }
    }
}


</style>
